import { Component, Input, SimpleChanges } from '@angular/core';
import { MemeTokenProfile } from '@src/app/modules/meme-dashboard/meme-dashboard.type';
import { initialOption } from '../../token-detail.data';
import { EchartsOption } from '@shared/directives/echarts.directive';
import { getHandleTimer } from '@src/app/modules/meme-dashboard/meme-dashboard.util';

@Component({
    selector: 'app-default-token-info',
    templateUrl: './default-token-info.component.html',
    styleUrls: ['./default-token-info.component.less'],
})
export class DefaultTokenInfoComponent {
    @Input() tokenInfo: MemeTokenProfile;

    initialOption = initialOption;

    optionsToBeUpdate: EchartsOption;

    hasImageDevStatsTokens: MemeTokenProfile['dev_stats']['tokens_deployed'];

    lastSmartBuyAge: string;

    ngOnChanges(changes: SimpleChanges) {
        if (changes['tokenInfo']) {
            this.setupChart(this.tokenInfo?.price_ohlc?.map(item => [item[0], item[4]]) || []);
            this.setDevStatsTokens();
            this.lastSmartBuyAge = getHandleTimer(this.tokenInfo?.smart_money_last_trade_block_timestamp);
        }
    }

    setupChart(data: [string, number][]) {
        const max = Math.max(...data.map(item => item[1]));
        const min = Math.min(...data.map(item => item[1]));

        const lastIndex = data.length - 1;
        const lastValue = data[lastIndex][1];

        this.optionsToBeUpdate = {
            grid: {
                top: 4,
                right: 4,
                bottom: 4,
                left: 4,
            },
            xAxis: {
                type: 'category',
                show: false,
                boundaryGap: false,
            },
            yAxis: {
                type: 'value',
                show: false,
                min,
                max,
                scale: false,
            },
            series: [
                {
                    type: 'line',
                    smooth: false,
                    symbolSize: 0,
                    data,
                    color: 'rgba(18, 190, 81, 1)',
                    areaStyle: {
                        color: {
                            colorStops: [
                                {
                                    offset: 0,
                                    color: 'rgba(45, 211, 106, 0.3)',
                                },
                                {
                                    offset: 1,
                                    color: 'rgba(45, 211, 106, 0)',
                                },
                            ],
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            type: 'linear',
                            global: false,
                        },
                    },
                    markPoint: {
                        symbol: 'circle',
                        symbolSize: 5,
                        itemStyle: {
                            color: '#fff',
                            borderWidth: 2,
                            borderColor: 'rgba(18, 190, 81, 1)',
                        },
                        data: [
                            {
                                coord: [lastIndex, lastValue],
                                name: 'last',
                            },
                        ],
                    },
                },
            ],
        };
    }

    private setDevStatsTokens() {
        const tokensWithLogo = this.tokenInfo?.dev_stats?.tokens_deployed?.filter(item => item.logo) || [];
        const tokensWithoutLogo = this.tokenInfo?.dev_stats?.tokens_deployed?.filter(item => !item.logo) || [];

        if (tokensWithLogo.length >= 6) {
            this.hasImageDevStatsTokens = tokensWithLogo.slice(0, 6);
        } else {
            const remainingCount = 6 - tokensWithLogo.length;
            this.hasImageDevStatsTokens = [...tokensWithLogo, ...tokensWithoutLogo.slice(0, remainingCount)];
        }
    }
}
